import { render } from "./AdminNavbar.vue?vue&type=template&id=37cb0c21&scoped=true"
import script from "./AdminNavbar.vue?vue&type=script&lang=js"
export * from "./AdminNavbar.vue?vue&type=script&lang=js"

import "./AdminNavbar.vue?vue&type=style&index=0&id=37cb0c21&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-37cb0c21"

export default script